import React from 'react';
import { Tabs, Tab } from 'react-bootstrap-tabs';
import '../../styles/yourOrders.css';
import Button from 'react-bulma-components/lib/components/button';
import {Redirect} from 'react-router-dom'

const someDummyData = [
    {
        orderId: 123,
        userId: 123,
        // Dimension: "10x10",
        technique: "Watercolor on canvas",
        imgUrl: [{ url1: require('../../assets/painting1.png') },
        { url: require('../../assets/painting2.png') },
        { url: require('../../assets/painting3.png') }],
        imgName: "The electric pikachu",
        cost: "500",
        profilePicture: require('../../assets/artist_profilepic.png'),
        ArtistName: "Salvadore Dali",
        Artistlocation: "Mumbai , India",
        buyRequestDone: false,
        likes: 313,
        liked: false,
        Year: 1997,
        artworkStory: "Mona Lisa is an iconic portrait beautifully painted by the legendry artist Leonardo da Vinci. The word “painting” is almost synonymous with Mona Lisa and it is arguably the most popular and talked about work of art. This portrait of a lady with an enigmatic smile is on display at the Louvre, Paris and is a subject of huge debates regarding the identity of the subject.",
        status: "IN PROGRESS",
        timeOfOrder: "19 October 2018",

    },
    {
        orderId: 123,
        userId: 123,
        // Dimension: "10x10",
        technique: "Watercolor on canvas",
        imgUrl: [{ url1: require('../../assets/painting1.png') },
        { url: require('../../assets/painting2.png') },
        { url: require('../../assets/painting3.png') }],
        imgName: "The electric pikachu",
        cost: "500",
        profilePicture: require('../../assets/artist_profilepic.png'),
        ArtistName: "Salvadore Dali",
        Artistlocation: "Mumbai , India",
        buyRequestDone: false,
        likes: 313,
        liked: false,
        Year: 1997,
        artworkStory: "Mona Lisa is an iconic portrait beautifully painted by the legendry artist Leonardo da Vinci. The word “painting” is almost synonymous with Mona Lisa and it is arguably the most popular and talked about work of art. This portrait of a lady with an enigmatic smile is on display at the Louvre, Paris and is a subject of huge debates regarding the identity of the subject.",
        status: "DECLINED",
        timeOfOrder: "19 October 2018",

    },
    {
        orderId: 123,
        userId: 123,
        // Dimension: "10x10",
        technique: "Watercolor on canvas",
        imgUrl: [{ url1: require('../../assets/painting1.png') },
        { url: require('../../assets/painting2.png') },
        { url: require('../../assets/painting3.png') }],
        imgName: "The electric pikachu",
        cost: "500",
        profilePicture: require('../../assets/artist_profilepic.png'),
        ArtistName: "Salvadore Dali",
        Artistlocation: "Mumbai , India",
        buyRequestDone: false,
        likes: 313,
        liked: false,
        Year: 1997,
        artworkStory: "Mona Lisa is an iconic portrait beautifully painted by the legendry artist Leonardo da Vinci. The word “painting” is almost synonymous with Mona Lisa and it is arguably the most popular and talked about work of art. This portrait of a lady with an enigmatic smile is on display at the Louvre, Paris and is a subject of huge debates regarding the identity of the subject.",
        status: "DELIVERED",
        timeOfOrder: "19 October 2018",

    },
]
export default class YourOrders extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            buyingTab: "visible",
            sellingTab: "hidden",
            ViewDetails : false
        }
    }


    handleButtonClicks(item) {
        switch(item){
            case ("ViewDetails") : {
                this.setState({
                    ViewDetails : true
                })
                break;
            } 
        }
    }
    toggleBuyingTab() {
        this.setState({
            buyingTab: "visible",
            sellingTab: "hidden"

        })
        // console.log("buying", this.state.buyingTab)
        // console.log("selling", this.state.sellingTab)
    }
    toggleSellingTab() {
        this.setState({
            buyingTab: "hidden",
            sellingTab: "visible"

        })
        // console.log("buying", this.state.buyingTab)
        // console.log("selling", this.state.sellingTab)
    }
    render() {

        if(this.state.ViewDetails){
            return(
                <Redirect push to = "/orderdetails" />
            )
        }
        return (
            <div className="back">
                <div className="heading-welcome">
                    MY ORDERS
                    <hr className="line-category-name margin-auto"></hr>
                </div>
                <div className="container yourOrders" id="container-order-details">
                    <div className="content" style={{ backgroundColor: "#F6F6F6", display: "flex", flexDirection: "column" }}>
                        <Tabs className="tabs pb-25" style={{ backgroundColor: "#FFFF", marginLeft: "30%", margin: "0px auto", minWidth: "100%", justifyContent: "center", flex: 1 }}>
                            <Tab label=" Buying" className="tab-button-buying" onClick={this.toggleBuyingTab.bind(this)}  >
                            
                                <div className="tabs-container">
                                    <Buying someDummyData={someDummyData} handleButtonClicks = {this.handleButtonClicks.bind(this)} />
                                </div>
                            </Tab>
                            <Tab label=" Selling" className="tab-button-buying" onClick={this.toggleSellingTab.bind(this)} >
                                <div className="tabs-container">
                                    <Selling someDummyData={someDummyData} handleButtonClicks={this.handleButtonClicks.bind(this)} />
                                </div>
                            </Tab>
                        </Tabs>
                    </div>
                </div>
            </div>
        )
    }

}

const Buying = (props) => {
    let { someDummyData,handleButtonClicks } = props;
    return (
        someDummyData.map((el, elIndex) =>
            <div key={elIndex} className="small-content-box" style={{ paddingLeft: "0%" }}>
                <div className="order-details-section">
                    <div className="order-display-picture-thumbnail">
                        <img style={{ height: "100%", width: "100%" }} src={require('../../assets/painting2.png')}></img>
                    </div>
                    <div className="order-name-technique-status">
                        <div className="order-name">
                            {el.imgName}
                        </div>
                        <div className="order-technique">
                            {el.technique}@{el.cost}
                        </div>
                        <div className="order-status">
                            <StatusBar status={el.status} />

                        </div>
                    </div>
                    <div className="order-detail-btn">
                        <BuyButtons handleButtonClicks={handleButtonClicks} status = {el.status}/>
                        <div className="time-of-order" id="time-of-order-details" >
                            {el.timeOfOrder}
                        </div>
                    </div>
                </div>
            </div>
        )

    )
}

const BuyButtons = (props) => {
    let { status,handleButtonClicks } = props;
    if (status == "IN PROGRESS")
        return (
            <Button onClick = {()=>handleButtonClicks("payForOrder")} id="order-details-button-orders" className="masterpieces-primary-buttons btn-pt8-pr-25">PAY FOR THE ORDER</Button>
        )
    else return <Button id="order-details-button-orders" onClick={()=> handleButtonClicks("ViewDetails")} className="masterpieces-secondary-buttons btn-pt8-pr-25">VIEW DETAILS</Button>
}
const Selling = (props) => {

    let { someDummyData } = props;
    return (
        someDummyData.map((el, elIndex) =>
            <div key={elIndex} className="small-content-box" style={{ paddingLeft: "0%" }}>
                <div className="order-details-section">
                    <div className="order-display-picture-thumbnail">
                        <img style={{ height: "100%", width: "100%" }} src={require('../../assets/painting2.png')}></img>
                    </div>
                    <div className="order-name-technique-status">
                        <div className="order-name">
                            {el.imgName}
                        </div>
                        <div className="order-technique">
                            {el.technique}@{el.cost}
                        </div>
                        <div className="order-status">
                            <StatusBar status={el.status} />

                        </div>
                    </div>
                    <div className="order-detail-btn-selling">
                        <Button id="order-details-button" className={(el.status == "IN PROGRESS") ? "masterpieces-primary-buttons btn-pt8-pr-25" : "masterpieces-secondary-buttons btn-pt8-pr-25"} >{(el.status == "IN PROGRESS") ? "PAY " : "VIEW DETAILS"}</Button>
                        <div className="time-of-order" id="time-of-order-details" >
                            {el.timeOfOrder}
                        </div>
                    </div>
                </div>
            </div>
        )

    )
}

const StatusBar = (props) => {
    let { status } = props;
    if (status == "IN PROGRESS")
        return (
            <div className="InProgress-Status-Bar" >
                <div className="status-name"> IN PROGRESS</div>
            </div>
        )
    if (status == "DECLINED")
        return (
            <div className="declined-Status-Bar">
                <div className="status-name">DECLINED</div>
            </div>
        )
    if (status == "DELIVERED")
        return (
            <div className="delivered-Status-Bar">
                <div className="status-name">DELIVERED</div>
            </div>
        )
    else return <div></div>

}



// WEBPACK FOOTER //
// ./src/components/orders/yourOrders.js